import { useEffect } from "react"
import { IntlProvider } from "react-intl"
import { Route, Routes, useParams } from "react-router-dom"
import { QURLI_SURVEYS, applyQurliFavicon } from "lib/common"
import {
  FemalePagesABGate,
  StartingScreen,
  StorePageAB,
  Survey,
  Ugc43Gate,
  Ugc44Gate,
} from "components/organisms"

import { SURVEY_CONFIG_V1 } from "config/v1"
import enLocales from "locales/en.json"
import ruLocales from "locales/ru.json"
import frLocales from "locales/fr.json"
import deLocales from "locales/de.json"
import itLocales from "locales/it.json"
import esLocales from "locales/es.json"
import ptLocales from "locales/pt.json"
import nlLocales from "locales/nl.json"
import trLocales from "locales/tr.json"
import hiLocales from "locales/hi.json"
import plLocales from "locales/pl.json"
import uaLocales from "locales/ua.json"
import zhHansLocales from "locales/zh-sm.json"
import zhHantLocales from "locales/zh-tr.json"
import { SURVEY_CONFIG_V2 } from "config/v2"
import { SURVEY_CONFIG_CHAT1 } from "config/chat-1"
import { SURVEY_CONFIG_CHAT2 } from "config/chat-2"
import { SURVEY_CONFIG_CHAT3 } from "config/chat-3"
import { SURVEY_CONFIG_CHAT4 } from "config/chat-4"
import { SURVEY_CONFIG_MAP1 } from "config/map-1"
import { SURVEY_CONFIG_MAP2 } from "config/map-2"
import { StorePage } from "components/organisms/store-page"
import { PAYGATE_CONFIG } from "config/paygate"
import { SURVEY_CONFIG_V43 } from "config/v43"
import { v55ConfigImages } from "config/v55"
import { PageWithCover } from "components/organisms/page-with-cover"
import { v57ConfigImages } from "config/v57"
import { v9ndConfigImages } from "config/v9-nd"
import { v9ndpbConfigImages } from "config/v9-nd-pb"
import { v57ndConfigImages } from "config/v57-nd"
import { v57ndpbConfigImages } from "config/v57-nd-pb"
import { v71ConfigImages } from "config/v71"
import { v72ConfigImages } from "config/v72"
import { v73ConfigImages } from "config/v73"
import { v74ConfigImages } from "config/v74"
import { v101ConfigImages } from "config/v101"
import { v107Config } from "config/v107"
import { v96Config } from "config/v96"
import { v91Config } from "config/v91"
import { v117Config } from "config/v117"
import { v120Config } from "config/v120"
import { SURVEY_CONFIG_V43_APPLOVIN } from "config/v43-applovin"
// import { SURVEY_CONFIG_V43_STRIPE } from "config/v43-stripe"
import { v114Config } from "config/v114"
import { v115Config } from "config/v115"
import { v116Config } from "config/v116"
import { v125ConfigImages } from "config/v125"
import { v126ConfigImages } from "config/v126"
import { v127ConfigImages } from "config/v127"
import { v128ConfigImages } from "config/v128"
import { v109ConfigImages } from "./config/v109"
import { v110ConfigImages } from "./config/v110"
import { v111ConfigImages } from "./config/v111"
import { v112Config } from "./config/v112"
import { v113Config } from "./config/v113"
import { v121ConfigImages } from "./config/v121"
import { v122ConfigImages } from "./config/v122"
import { v123ConfigImages } from "./config/v123"
import { v124ConfigImages } from "./config/v124"
import { v129Config } from "./config/v129"
import { v130Config } from "./config/v130"
import { v99ConfigImages } from "./config/v99"
import { SURVEY_CONFIG_S43 } from "./config/s43"
import { SURVEY_CONFIG_UGC_V1 } from "./config/ugc-v1"
import { SURVEY_CONFIG_UGC_V2 } from "config/ugc-v2"
import { SURVEY_CONFIG_UGC43_NO_PAYWALL } from "config/ugc43"
import { PleasurePage } from "./pages/pleasure"
import { BerlinPage } from "./pages/berlin"
import { StorePageImagesOnly } from "./components/organisms/store-page-images-only"
import { v131Images } from "./config/v131"
import { v132Config } from "./config/v132"
import { v133Config } from "./config/v133"
import { v134Config } from "./config/v134"
import { v135Config } from "./config/v135"
import { v136Config } from "./config/v136"
import { v137Config } from "./config/v137"
import { v138Config } from "./config/v138"
import { v139Config } from "./config/v139"
import { v140Config } from "./config/v140"
import { v141Config } from "./config/v141"
import { v142Config } from "./config/v142"
import { v143Config } from "./config/v143"
import { v144Config } from "./config/v144"
import { v145Config } from "./config/v145"
import { v146Config } from "./config/v146"
import { v147Config } from "./config/v147"
import { v148Config } from "./config/v148"
import { v149Config } from "./config/v149"
import { v150Config } from "./config/v150"
import { v151Config } from "./config/v151"
import { v152Config } from "./config/v152"
import { v153Config } from "./config/v153"
import { v154Config } from "./config/v154"
import { v155Config } from "./config/v155"
import { v156Config } from "./config/v156"

const MESSAGES: Record<string, any> = {
  en: enLocales,
  ru: ruLocales,
  fr: frLocales,
  de: deLocales,
  it: itLocales,
  es: esLocales,
  pt: ptLocales,
  nl: nlLocales,
  tr: trLocales,
  hi: hiLocales,
  pl: plLocales,
  ua: uaLocales,
  "zh-hans": zhHansLocales,
  "zh-hant": zhHantLocales,
}

const LOCALIZED_SURVEYS = [
  "nv3",
  "nv9",
  "nv9-nd",
  "nv57",
  "nv72",
  "nv73",
  "nv49",
  "nv71",
  "nv96",
  "nv99",
  "nv109",
  "nv113",
  "nv129",
  "pleasure",
  "berlin_v2",
  "ugc43",
  "ugc44",
  "ugc_v5",
]

export default function App() {
  const { locale = "en", ...rest } = useParams()
  const survey = rest["*"]
  const messages = LOCALIZED_SURVEYS.includes(survey || "")
    ? MESSAGES[locale] || MESSAGES.en
    : MESSAGES.en

  useEffect(() => {
    if (QURLI_SURVEYS.includes(survey || "")) {
      applyQurliFavicon()
    }
  }, [survey])

  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale="en">
      <Routes>
        {/*<Route*/}
        {/*  path="s43"*/}
        {/*  element={*/}
        {/*    <Survey*/}
        {/*      surveyId="s43"*/}
        {/*      steps={SURVEY_CONFIG_V43_STRIPE}*/}
        {/*      StartScreen={StartingScreen}*/}
        {/*    />*/}
        {/*  }*/}
        {/*/>*/}
        <Route
          path="nv1"
          element={
            <Survey
              surveyId="nv1"
              steps={SURVEY_CONFIG_V1}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="nv2"
          element={
            <Survey
              surveyId="nv2"
              steps={SURVEY_CONFIG_V2}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="av2"
          element={
            <Survey
              surveyId="av2"
              steps={SURVEY_CONFIG_V2}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="chat_v1"
          element={<Survey surveyId="chat_v1" steps={SURVEY_CONFIG_CHAT1} />}
        />
        <Route
          path="chat_v2"
          element={<Survey surveyId="chat_v2" steps={SURVEY_CONFIG_CHAT2} />}
        />
        <Route
          path="chat_v3"
          element={<Survey surveyId="chat_v3" steps={SURVEY_CONFIG_CHAT3} />}
        />
        <Route
          path="chat_v4"
          element={<Survey surveyId="chat_v4" steps={SURVEY_CONFIG_CHAT4} />}
        />
        <Route
          path="map_v1"
          element={<Survey surveyId="map_v1" steps={SURVEY_CONFIG_MAP1} />}
        />
        <Route
          path="map_v2"
          element={<Survey surveyId="map_v2" steps={SURVEY_CONFIG_MAP2} />}
        />
        <Route path="nv3" element={<StorePage surveyId="nv3" />} />
        <Route path="nv9" element={<StorePage surveyId="nv9" />} />
        <Route
          path="nv55"
          element={<StorePage surveyId="nv55" images={v55ConfigImages} />}
        />
        <Route
          path="nv57"
          element={
            <StorePage
              surveyId="nv57"
              images={v57ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv71"
          element={
            <FemalePagesABGate>
              {["quiz.anythingbutboring.app", "anythingfun.app"].includes(
                window.location.hostname,
              ) && locale === "en" ? (
                <StorePageAB
                  surveyId="nv71"
                  staticVariantName="dating_with_intention"
                />
              ) : (
                <StorePage
                  surveyId="nv71"
                  images={v71ConfigImages}
                  reviewsKeys={{ ru: "paygate.reviews.new" }}
                />
              )}
            </FemalePagesABGate>
          }
        />
        <Route path="nv71-ab" element={<StorePageAB surveyId="nv71-ab" />} />
        <Route
          path="nv72"
          element={
            <StorePage
              surveyId="nv72"
              images={v72ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv73"
          element={
            <StorePage
              surveyId="nv73"
              images={v73ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv74"
          element={
            <StorePage
              surveyId="nv74"
              images={v74ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv101"
          element={
            <StorePage
              surveyId="nv101"
              images={v101ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv9-nd"
          element={<StorePage surveyId="nv9-nd" images={v9ndConfigImages} />}
        />
        <Route
          path="nv9-nd-pb"
          element={
            <StorePage surveyId="nv9-nd-pb" images={v9ndpbConfigImages} />
          }
        />
        <Route
          path="nv57-nd"
          element={
            <StorePage
              surveyId="nv57-nd"
              images={v57ndConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv57-nd-pb"
          element={
            <StorePage
              surveyId="nv57-nd-pb"
              images={v57ndpbConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route path="nv49" element={<PageWithCover surveyId="nv49" />} />
        <Route
          path="nv107"
          element={
            <PageWithCover
              surveyId="nv107"
              images={v107Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
              }}
            />
          }
        />
        <Route
          path="nv117"
          element={
            <PageWithCover
              surveyId="nv117"
              images={v117Config}
              theme={{
                button: {
                  className: "capitalize mt-6 pulse-animation-pink",
                },
                container: {
                  className: "nv117-container",
                },
              }}
            />
          }
        />
        <Route
          path="nv120"
          element={
            <PageWithCover
              surveyId="nv120"
              images={v120Config}
              theme={{
                button: {
                  className: "capitalize mt-6 pulse-animation-pink",
                },
              }}
            />
          }
        />
        <Route
          path="nv96"
          element={
            <PageWithCover
              surveyId="nv96"
              images={v96Config}
              theme={{ button: { className: "capitalize" } }}
            />
          }
        />
        <Route
          path="nv91"
          element={
            <PageWithCover
              surveyId="nv91"
              images={v91Config}
              theme={{ button: { className: "capitalize" } }}
            />
          }
        />
        <Route
          path="nv114"
          element={
            <PageWithCover
              surveyId="nv114"
              images={v114Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv115"
          element={
            <PageWithCover
              surveyId="nv115"
              images={v115Config}
              theme={{
                button: { className: "capitalize  pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv116"
          element={
            <PageWithCover
              surveyId="nv116"
              images={v116Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="paygate"
          element={
            <Survey
              surveyId="paygate"
              steps={PAYGATE_CONFIG}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="nv43"
          element={
            <Survey
              surveyId="nv43"
              steps={SURVEY_CONFIG_V43}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="al43"
          element={
            <Survey
              surveyId="al43"
              steps={SURVEY_CONFIG_V43_APPLOVIN}
              StartScreen={StartingScreen}
            />
          }
        />
        <Route
          path="nv125"
          element={
            <StorePage
              surveyId="nv125"
              images={v125ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv126"
          element={
            <StorePage
              surveyId="nv126"
              images={v126ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv127"
          element={
            <StorePage
              surveyId="nv127"
              images={v127ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv128"
          element={
            <StorePage
              surveyId="nv128"
              images={v128ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv109"
          element={
            <StorePage
              surveyId="nv109"
              images={v109ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
              buttonTextKey="v109.button"
            />
          }
        />
        <Route
          path="nv110"
          element={
            <StorePage
              surveyId="nv110"
              images={v110ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv111"
          element={
            <StorePage
              surveyId="nv111"
              images={v111ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv112"
          element={
            <PageWithCover
              surveyId="nv112"
              images={v112Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv113"
          element={
            <PageWithCover
              surveyId="nv113"
              images={v113Config}
              buttonTextKey="v113.button"
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv121"
          element={
            <StorePage
              surveyId="nv121"
              images={v121ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv122"
          element={
            <StorePage
              surveyId="nv122"
              images={v122ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv123"
          element={
            <StorePage
              surveyId="nv123"
              images={v123ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv124"
          element={
            <StorePage
              surveyId="nv124"
              images={v124ConfigImages}
              buttonClassName="mt-3 rounded-[16px]"
            />
          }
        />
        <Route
          path="nv129"
          element={
            <FemalePagesABGate>
              <PageWithCover
                surveyId="nv129"
                images={v129Config}
                buttonTextKey="v129.button"
                theme={{
                  button: { className: "uppercase pulse-animation-pink my-6" },
                  container: { className: "nv129-container" },
                }}
              />
            </FemalePagesABGate>
          }
        />
        <Route
          path="nv130"
          element={
            <PageWithCover
              surveyId="nv130"
              images={v130Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink my-6" },
                container: { className: "nv129-container" },
              }}
            />
          }
        />
        <Route
          path="nv99"
          element={
            <StorePage
              surveyId="nv99"
              images={v99ConfigImages}
              reviewsKeys={{ ru: "paygate.reviews.new" }}
            />
          }
        />
        <Route
          path="s43"
          element={
            <Survey
              surveyId="s43"
              steps={SURVEY_CONFIG_S43}
              StartScreen={StartingScreen}
              classNames={{
                content: "max-w-[450px] !pt-0",
                container: "!p-0",
              }}
            />
          }
        />
        <Route
          path="nv131"
          element={<StorePageImagesOnly surveyId="nv131" images={v131Images} />}
        />
        <Route
          path="nv132"
          element={
            <PageWithCover
              surveyId="nv132"
              images={v132Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv133"
          element={
            <PageWithCover
              surveyId="nv133"
              images={v133Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv134"
          element={
            <PageWithCover
              surveyId="nv134"
              images={v134Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv135"
          element={
            <PageWithCover
              surveyId="nv135"
              images={v135Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv136"
          element={
            <PageWithCover
              surveyId="nv136"
              images={v136Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv137"
          element={
            <PageWithCover
              surveyId="nv137"
              images={v137Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv138"
          element={
            <PageWithCover
              surveyId="nv138"
              images={v138Config}
              theme={{
                button: { className: "capitalize mt-6 pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv139"
          element={
            <PageWithCover
              surveyId="nv139"
              images={v139Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv140"
          element={
            <PageWithCover
              surveyId="nv140"
              images={v140Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv141"
          element={
            <PageWithCover
              surveyId="nv141"
              images={v141Config}
              theme={{
                button: { className: "capitalize pulse-animation-pink" },
              }}
            />
          }
        />
        <Route
          path="nv142"
          element={
            <PageWithCover
              surveyId="nv142"
              images={v142Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
              }}
            />
          }
        />
        <Route
          path="nv143"
          element={<StorePageImagesOnly surveyId="nv143" images={v143Config} />}
        />
        <Route
          path="nv144"
          element={
            <StorePage
              surveyId="nv144"
              images={v144Config}
              hideReviews
              buttonTextKey="v144.button"
              buttonClassName="bg-[#0D58CF]"
            />
          }
        />
        <Route
          path="nv145"
          element={<StorePage surveyId="nv145" images={v145Config} />}
        />
        <Route
          path="nv146"
          element={<StorePage surveyId="nv146" images={v146Config} />}
        />
        <Route
          path="nv147"
          element={
            <PageWithCover
              surveyId="nv147"
              images={v147Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
                title: { className: "max-w-[240px] mx-auto" },
              }}
            />
          }
        />
        <Route
          path="nv148"
          element={<StorePage surveyId="nv148" images={v148Config} />}
        />
        <Route
          path="nv149"
          element={<PageWithCover surveyId="nv149" images={v149Config} />}
        />
        <Route
          path="nv150"
          element={<PageWithCover surveyId="nv150" images={v150Config} />}
        />
        <Route
          path="nv151"
          element={<PageWithCover surveyId="nv151" images={v151Config} />}
        />
        <Route
          path="nv152"
          element={
            <PageWithCover
              surveyId="nv152"
              images={v152Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
                title: { className: "max-w-[240px] mx-auto" },
              }}
            />
          }
        />
        <Route
          path="nv153"
          element={
            <PageWithCover
              surveyId="nv153"
              images={v153Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
                title: { className: "max-w-[240px] mx-auto" },
              }}
            />
          }
        />
        <Route
          path="nv154"
          element={
            <PageWithCover
              surveyId="nv154"
              images={v154Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
                title: { className: "max-w-[240px] mx-auto" },
              }}
            />
          }
        />
        <Route
          path="nv155"
          element={<PageWithCover surveyId="nv155" images={v155Config} />}
        />
        <Route
          path="nv156"
          element={
            <PageWithCover
              surveyId="nv156"
              images={v156Config}
              theme={{
                button: {
                  className: "bg-black capitalize mt-6 pulse-animation",
                },
                title: { className: "max-w-[240px] mx-auto" },
              }}
            />
          }
        />
        <Route
          path="ugc_v1"
          element={
            <Survey
              surveyId="ugc_v1"
              steps={SURVEY_CONFIG_UGC_V1}
              classNames={{
                content: "max-w-[450px] !pt-0",
                container: "!p-0 max-w-full w-[450px]",
              }}
            />
          }
        />
        <Route
          path="ugc_v2"
          element={
            <Survey
              surveyId="ugc_v2"
              steps={SURVEY_CONFIG_UGC_V2}
              classNames={{
                content: "max-w-[450px] !pt-0",
                container: "!p-0 max-w-full w-[450px]",
              }}
            />
          }
        />
        <Route path="ugc43" element={<Ugc43Gate />} />
        <Route path="ugc44" element={<Ugc44Gate />} />
        <Route
          path="ugc_v5"
          element={
            <Survey surveyId="ugc_v5" steps={SURVEY_CONFIG_UGC43_NO_PAYWALL} />
          }
        />
        <Route path="pleasure" element={<PleasurePage locale={locale} />} />
        <Route path="berlin" element={<BerlinPage />} />
        <Route
          path="berlin_v2"
          element={
            <BerlinPage
              surveyId="berlin_v2"
              locale={locale}
              showBrowserHint={false}
              titleKey="berlin_v2.title"
              buttonKey="berlin_v2.button"
            />
          }
        />
      </Routes>
    </IntlProvider>
  )
}
